export default __webpack_public_path__ + "static/media/z010ma0b.30d2ffe6.mp3";